import React from "react";
import Skills from "../skills/Skills";

const resumeContent = [
  {
    jobPosition: `Full Stack Developer`,
    jobType: `WatanNetwork | Remote`,
    jobDuration: `Jan 2016 - Present`,
    timeDuraton: `Full Time`,
    compnayName: "WatanNetwork LLC",
    jobDescription: `Fast delivery for Videos Revenue Dashboard that automate and solves the problem on splitting revenue 
    with our partner based on their shares. Working online with the company for more than 5 years online while managing the different time zone and 
    communication and delivery with ease. Being a team lead to upgrade our YouTube Dashboard to use more recent  technologies such as SPA and 
    migrating to newer version of YouTube API  
     .`,
  },
  {
    jobPosition: `Web Developer`,
    jobType: `Larsa | Remote`,
    jobDuration: `June 2013 - Oct 2014`,
    timeDuraton: `Full Time`,
    compnayName: "Larsa LLC",
    jobDescription: `Optimizing front end code to produce stunning responsive and adaptive websites that work across a range of devices.
    Building sites to function cross-platform and cross-browser. 
    Themeing mobile version website.
    Creating and modifying templates for a CMS or web development framework.
    HTML CSS templates for mailing system (MailChimp - phpList) -WhatsApp web integration for companies.
    Developing websites based on WordPress , Drupal7. 
    Developing eCommerce website based on WordPress and woo- commerce`,
  },
  {
    jobPosition: `Web Developer`,
    jobType: `Gamepower7 | Remote`,
    jobDuration: `May 2011 - Mar 2013`,
    timeDuraton: `Full Time`,
    compnayName: "Media Globe",
    jobDescription: `Developing websites based on drupal 6. 
    Developing websites based on xml exported files connected to java engine. 
    Installing , Managing , Adding plugins , Very well theming vBulletin. 
    Working and Managing wikis based on MediaWiki. 
    Coordinating with designers, administrators, project managers and other programmers.`,
  },
];

const educatonContent = [
  {
    passingYear: "2021-2023",
    degreeTitle: "MSc Software Engineering",
    instituteName: "Cardiff University",
  },
  {
    passingYear: "2021-2021",
    degreeTitle: "Ract Bootcamp",
    instituteName: "Re:Coded & Flatiron School",
  },
  {
    passingYear: "2012-2015",
    degreeTitle: "Bachelor Degree in Information Technology",
    instituteName: "Syrian Virtual University",
  },
];

const Resume = () => {
  return (
    <>
      <section id="resume" className="section">
        <div className="container">
          <div className="title">
            <h3>Experience.</h3>
          </div>
          {/* End title */}
          <div className="resume-box">
            {resumeContent.map((val, i) => (
              <div className="resume-row" key={i}>
                <div className="row">
                  <div className="col-md-4 col-xl-3">
                    <div className="rb-left">
                      <h6>{val.jobPosition}</h6>
                      <label>{val.jobType}</label>
                      <p>{val.jobDuration}</p>
                      <div className="rb-time">{val.timeDuraton}</div>
                    </div>
                  </div>
                  <div className="col-md-8 col-xl-9">
                    <div className="rb-right">
                      <h6>{val.compnayName}</h6>
                      <p>{val.jobDescription}</p>
                    </div>
                  </div>
                </div>
              </div>
              // End resume-row
            ))}
          </div>

          {/* separated */}
          <div
            className="separated"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "img/border-dark.png"
              })`,
            }}
          ></div>
          {/* End separated */}

          <div className="title">
            <h3>Education & Skills</h3>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-4 m-15px-tb">
              <ul className="aducation-box">
                {educatonContent.map((val, i) => (
                  <li key={i}>
                    <span>{val.passingYear}</span>
                    <h6>{val.degreeTitle} </h6>
                    <p>{val.instituteName}</p>
                  </li>
                ))}
              </ul>
            </div>
            {/* End .col */}

            <div className="col-lg-7 ml-auto m-15px-tb">
              <Skills />
            </div>
            {/* End .col */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Resume;
